import React, { useEffect, useState, useContext } from "react";
import { TabList, Tab } from "@fluentui/react-tabs";
import CustomTab from "./CustomTab";
import "./TabStyles.css";
import NextPreviousSection from "./NextPreviousSection";
import { DefaultButton, PrimaryButton } from "@fluentui/react";
import { t } from "i18next";
import { ACTIONS, BORDER } from "../../constants/Constants";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";
import BackResIcon from "../SVGComponents/ResponsiveScreenIcon/BackResIcon";
import DesktopTabView from "./DesktopTabView";
import MobileTabView from "./MobileTabView";
import themeContext from "../../context/theme/ThemeContext";

const TabContainer = (props) => {
  const [selectedValue, setSelectedValue] = useState(`${props.uniqueKey}1`);
  const {getThemeColor,themeName} = useContext(themeContext);
  const [prevState, setPrevState] = useState(`${props.uniqueKey}1`);
  const [navigateUser, setNavigateUser] = useState({
    navigate: false,
    selectedValue: "",
    headerName: "",
  });
  const [routerState, setRouterState] = useState(
    props.state ? props.state.action : null
  );

  const handleNextClick = () => {
    if (
      parseInt(getNumberFromString(selectedValue)) < props.tabDetails.length
    ) {
      let nextTab = parseInt(getNumberFromString(selectedValue)) + 1;
      setSelectedValue(props.uniqueKey + nextTab.toString());
      setPrevState(props.uniqueKey + "1");
      if (isMobile) {
        let filteredHeaderName = props.tabDetails.filter((tabElement) => {
          return (
            props.uniqueKey + tabElement.selectedKey ==
            props.uniqueKey + nextTab.toString()
          );
        });
        setNavigateUser(() => {
          const newItem = { ...navigateUser };
          newItem.navigate = true;
          newItem.selectedValue = nextTab.toString();
          newItem.headerName = filteredHeaderName[0].tabName;
          return newItem;
        });
      }
      props.onNextClick(getNumberFromString(selectedValue));
    }
  };

  const getNumberFromString = (str) => {
    return str.split("_")[1];
  };

  const handlePreviousClick = () => {
    if (parseInt(getNumberFromString(selectedValue)) > 1) {
      let nextTab = parseInt(getNumberFromString(selectedValue)) - 1;
      setSelectedValue(props.uniqueKey + nextTab.toString());

      if (isMobile) {
        let filteredHeaderName = props.tabDetails.filter((tabElement) => {
          return (
            props.uniqueKey + tabElement.selectedKey ==
            props.uniqueKey + nextTab.toString()
          );
        });
        setNavigateUser(() => {
          const newItem = { ...navigateUser };
          newItem.navigate = true;
          newItem.selectedValue = nextTab.toString();
          newItem.headerName = filteredHeaderName[0].tabName;
          return newItem;
        });
      }
    }
  };

  const onTabSelect = (event, data) => {
    let previousState = selectedValue;
    setSelectedValue(data.value);
    if (props.tabValidation != undefined && props.tabValidation != null) {
      props.tabValidation(data.value, previousState);
    }
  };

  useEffect(() => {
    if (!isMobile) {
      document.getElementById(selectedValue).style.backgroundColor = getThemeColor("active-side-tab");
      for (let i = 1; i <= props.tabDetails.length; i++) {
        if (parseInt(getNumberFromString(selectedValue)) != i) {
            document.getElementById(
              props.uniqueKey.toString() + i
              ).style.backgroundColor = getThemeColor("alternate-side-tab");
              document.getElementById(props.uniqueKey.toString() + i).style.borderBottom = getThemeColor("border");
        }
      }
    }
    if(props.setUpdateActiveTab != null && props.setUpdateActiveTab != undefined){
      props.setUpdateActiveTab(null);
    }
  }, [selectedValue,themeName]);

  useEffect(() => {
    if (!isMobile) {
      document.getElementById(
        `${props.uniqueKey}${
          props.defaultSelectedValue ? props.defaultSelectedValue : 1
        }`
      ).style.backgroundColor = getThemeColor("active-side-tab");
        
      for (let i = 1; i <= props.tabDetails.length; i++) {
        if (parseInt(getNumberFromString( `${props.uniqueKey}${
          props.defaultSelectedValue ? props.defaultSelectedValue : 1
        }`)) != i) {
            document.getElementById(
              props.uniqueKey.toString() + i
              ).style.backgroundColor =  getThemeColor("alternate-side-tab");
              document.getElementById(props.uniqueKey.toString() + i).style.borderBottom = getThemeColor("border");
        }
      }

      setSelectedValue(
        `${props.uniqueKey}${
          props.defaultSelectedValue ? props.defaultSelectedValue : 1
        }`
      );  
    }
  }, []);

  useEffect(()=>{
    if(props.updateActiveTab != null && props.updateActiveTab != undefined){
      setSelectedValue(`${props.uniqueKey}${props.updateActiveTab}`)
    }
  },[props.updateActiveTab])

  useEffect(() => {
    if (props.state) {
      setRouterState(props.state.action);
    }
  }, [props.state]);

  const onMobileTabSelect = (event, data, navigate) => {
    
    let filteredHeaderName = props.tabDetails.filter((tabElement) => {
      return props.uniqueKey + tabElement.selectedKey == data.value;
    });
    setSelectedValue(data.value);
    setNavigateUser(() => {
      const newItem = { ...navigateUser };
      newItem.navigate = true;
      newItem.selectedValue =
        props.uniqueKey + filteredHeaderName[0].selectedKey;
      newItem.headerName = filteredHeaderName[0].tabName;
      return newItem;
    });
  };

  return (
    <>
      {!isMobile ? (
        <DesktopTabView
          uniqueKey={props.uniqueKey}
          selectedValue={selectedValue}
          onTabSelect={onTabSelect}
          tabDetails={props.tabDetails}
          routerState={props.action}
          onCancelClick={props.onCancelClick}
          onSubmitClick={props.onSubmitClick}
          onEditClick={props.onEditClick}
          isMobile={isMobile}
          getNumberFromString={getNumberFromString}
          handleNextClick={handleNextClick}
          handlePreviousClick={handlePreviousClick}
          NoOfTabs={props.NoOfTabs}
          previousNextButton={props.previousNextButton}
          topButtons={
            props.topButtons == undefined || props.topButtons == null
              ? []
              : props.topButtons
          }
          breadCrumbItems={
            props.breadCrumbItems == undefined || props.breadCrumbItems == null
              ? []
              : props.breadCrumbItems
          }
          leftPanelWidth={props.leftPanelWidth}
          headerTopButtons={props.headerTopButtons}
          customHeight={props.customHeight}
        />
      ) : (
        <MobileTabView
          uniqueKey={props.uniqueKey}
          selectedValue={selectedValue}
          onMobileTabSelect={onMobileTabSelect}
          tabDetails={props.tabDetails}
          routerState={routerState}
          onCancelClick={props.onCancelClick}
          onSubmitClick={props.onSubmitClick}
          onEditClick={props.onEditClick}
          isMobile={isMobile}
          getNumberFromString={getNumberFromString}
          handleNextClick={handleNextClick}
          handlePreviousClick={handlePreviousClick}
          NoOfTabs={props.NoOfTabs}
          previousNextButton={props.previousNextButton}
          navigateUser={navigateUser}
          setNavigateUser={setNavigateUser}
          mobileTabHeader={props.mobileTabHeader}
        />
      )}
    </>
  );
};

export default TabContainer;
